import styles from './sucessCard.module.css';

export const SuccessCard = ({children}) => {
    return (
        <div className={styles.successCard}>
            {children}
        </div>
    );
};
